
import styled from "@emotion/styled/macro";
import React, {PropsWithChildren} from "react";
import { useNavigate } from 'react-router-dom';

const BackButtonDiv = styled.div`
  flex-grow: 1;
  position: relative;
  overflow:hidden;
  svg.back {
    color: var(--secondary-color, transparent);
    position:absolute;
    margin-top: 10px;
    margin-left: 10px;
    z-index: 10000;
  }

`

const BackButtonImg = styled.img`
  position:absolute;
  margin-top: 10px;
  margin-left: 10px;
  z-index: 10000;
`



const BackButtonLayout: React.FC<PropsWithChildren> = ({children}) => {
    const navigate = useNavigate();

    return (
        <BackButtonDiv>

            <svg className={"back"} onClick={() => navigate(-1)} width="136" height="48" viewBox="-3 -3 141 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M46 30L40 24L46 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M70.7858 23.632V23.6C72.0338 23.136 72.7858 22.208 72.7858 21.008C72.7858 19.008 71.0578 17.68 68.4978 17.68H63.5858V30H68.8978C71.5858 30 73.3618 28.608 73.3618 26.512C73.3618 25.104 72.3858 24.064 70.7858 23.632ZM68.6098 19.408C69.7458 19.408 70.4978 20.112 70.4978 21.168C70.4978 22.224 69.7458 22.912 68.6098 22.912H65.7938V19.408H68.6098ZM69.0098 28.272H65.7938V24.464H69.0098C70.2418 24.464 71.0738 25.232 71.0738 26.368C71.0738 27.504 70.2418 28.272 69.0098 28.272ZM81.1289 21.648V23.136H81.0969C80.6169 22.112 79.4489 21.488 78.1529 21.488C76.0249 21.488 74.5849 23.216 74.5849 25.824C74.5849 28.432 76.0089 30.16 78.1369 30.16C79.4489 30.16 80.6329 29.536 81.0969 28.512H81.1289V30H83.2409V21.648H81.1289ZM78.9369 28.48C77.6249 28.48 76.7449 27.408 76.7449 25.824C76.7449 24.224 77.6249 23.152 78.9369 23.152C80.2489 23.152 81.1289 24.224 81.1289 25.824C81.1289 27.408 80.2489 28.48 78.9369 28.48ZM89.2792 30.16C91.4712 30.16 93.1192 28.88 93.4072 26.96H91.3112C91.1352 27.872 90.3192 28.48 89.2792 28.48C87.9832 28.48 87.1352 27.408 87.1352 25.824C87.1352 24.224 87.9832 23.168 89.2792 23.168C90.2872 23.168 91.0712 23.76 91.2792 24.672H93.3592C93.0712 22.768 91.4232 21.488 89.2792 21.488C86.6872 21.488 84.9752 23.216 84.9752 25.824C84.9752 28.432 86.6872 30.16 89.2792 30.16ZM95.0184 30H97.1304V17.68H95.0184V30ZM99.8184 25.392L103.29 21.648H100.89L97.3704 25.456L101.466 30H103.93L99.8184 25.392Z" fill="currentColor"/>
                <path d="M24 2H112V-2H24V2ZM112 46H24V50H112V46ZM24 46C11.8497 46 2 36.1503 2 24H-2C-2 38.3594 9.6406 50 24 50V46ZM134 24C134 36.1503 124.15 46 112 46V50C126.359 50 138 38.3594 138 24H134ZM112 2C124.15 2 134 11.8497 134 24H138C138 9.6406 126.359 -2 112 -2V2ZM24 -2C9.6406 -2 -2 9.6406 -2 24H2C2 11.8497 11.8497 2 24 2V-2Z" fill="currentColor"/>
            </svg>
            {children}
        </BackButtonDiv>


)
}
export default BackButtonLayout;
